import axios from 'axios';
import picsioConfig from '../../../../../config';
import sdk from '../../sdk';
import prepareSearchQuery from './prepareSearchQuery';
import { isRoutePreview } from '../history';

const PAGE_SIZE = 50;

function searchMain(from, sort, geoData, assets, cancelToken) {
  const data = {
    ...prepareSearchQuery(),
    size: geoData ? 'all' : PAGE_SIZE,
    from,
    sort,
  };

  if (isRoutePreview()) {
    const assetId = window.location.pathname.split('/').pop();
    const asset = assets.find((a) => a._id === assetId);
    if (asset && asset.trashed) data.trashed = true;
  }
  if (geoData) {
    data.geoData = true;
    data.onlyIds = true;
    data.zoom = Number(data.zoom);
  }

  return sdk.assets.search(data, cancelToken);
}

async function searchPublic(from, sort, cancelToken) {
  const query = prepareSearchQuery();
  query.collectionIds = query.collectionIds?.length ? query.collectionIds : picsioConfig.access.tag._id;
  try {
    return await sdk.assets.searchPublic(
      picsioConfig.apiBaseUrl,
      window.websiteConfig.alias,
      {
        size: PAGE_SIZE,
        from,
        sort,
        ...query,
      },
      cancelToken,
    );
  } catch (error) {
    if (error.status === 401) {
      window.location.replace(
        `/websites/signin?alias=${window.websiteConfig.alias}`,
      );
    }
    throw error; // actually we should write something meaningful to user here
  }
}

let cancelToken = null;

export default function search(...args) {
  const searchMethod = picsioConfig.isMainApp ? searchMain : searchPublic;

  if (cancelToken?.cancel) cancelToken.cancel();

  cancelToken = axios.CancelToken.source();

  return searchMethod(...args, cancelToken.token);
}
